import parse from 'html-react-parser';
import { Fragment } from 'react';

import { Link } from '@larvitu/shared/next/mui';
import { prefixServerUrl } from '@larvitu/shared/utils/server';

import type { HTMLReactParserOptions } from 'html-react-parser';
import type { FC } from 'react';

export interface ParserProps {
  children: string;
  options?: HTMLReactParserOptions;
}

export const HtmlParser: FC<ParserProps> = ( {
  children,
  options: initialOptions,
} ) => {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      /* anchor */

      if ('attribs' in domNode && domNode.name === 'a') {
        return (
          <Link
            underline="hover"
            href={domNode.attribs.href ?? ''}
            target={'_blank'}
          >
            {domNode.children[0].data}
          </Link>
        );
      }

      /* image */

      if ('attribs' in domNode && typeof domNode.attribs.srcset === 'string') {
        const { srcset, ...rest } = domNode.attribs;

        return (
          <img
            {...rest}
            width="100%"
            srcSet={srcset
              .split(',')
              .map( (src) => prefixServerUrl(src) )
              .join(',')}
            src={prefixServerUrl(domNode.attribs.src)}
          />
        );
      }

      // return null;
      return domNode;
    },
    ...initialOptions,
  };

  return (
    <Fragment>
      {parse(children, options)}
    </Fragment>
  );
};
